import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { StarField } from './StarField';
import { ShieldCheckIcon, DownloadIcon, SparklesIcon } from 'lucide-react';
export function CTASection() {
  return <section id="oferta" className="relative bg-night-800 py-20 md:py-28 overflow-hidden scroll-mt-8" data-id="element-2">
      <StarField data-id="element-3" />

      {/* Radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full" style={{
      background: 'radial-gradient(circle, rgba(245,197,66,0.12) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-4" />

      <div className="relative z-10 max-w-2xl mx-auto px-5 sm:px-8" data-id="element-5">
        <AnimatedSection data-id="element-6">
          <div className="text-center" data-id="element-7">
            <SparklesIcon className="w-8 h-8 text-gold-400 mx-auto mb-6" aria-hidden="true" data-id="element-8" />

            <h2 className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-cream-100 mb-6 leading-tight" data-id="element-9">
              Recupera tu derecho a{' '}
              <span className="text-gold-400 italic" data-id="element-10">dormir</span> hoy mismo
            </h2>

            <p className="font-dm-sans text-lg text-cream-200/70 leading-relaxed mb-10 max-w-lg mx-auto" data-id="element-11">
              El acceso al Método Noches en Paz y todos sus recursos tiene un
              valor simbólico comparado con una sola noche de descanso real.
            </p>

            {/* Product image small */}
            <div id="oferta-compra" className="scroll-mt-16 mb-10" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/tpe1uDUP7iXWBFC3pBKqZb/heylloyd-image-1773529112244.png" alt="Método Noches en Paz eBook" className="w-48 sm:w-56 h-auto mx-auto rounded-xl shadow-xl shadow-night-900/60" data-id="element-13" />
            </div>

            {/* Price block */}
            <div className="mb-8" data-id="element-14">
              <p className="font-dm-sans text-sm text-cream-200/40 line-through mb-1" data-id="element-15">
                $49.900 COP
              </p>
              <p className="font-playfair text-4xl sm:text-5xl font-bold text-gold-400" data-id="element-16">
                $24.900
                <span className="text-lg sm:text-xl font-dm-sans font-medium text-gold-400/70 ml-1" data-id="element-17">
                  COP
                </span>
              </p>
              <p className="font-dm-sans text-sm text-cream-200/50 mt-2" data-id="element-18">
                Precio especial por tiempo limitado
              </p>
            </div>

            {/* CTA Button */}
            <a href="https://www.solucionactiva.com/cart/51207365951792:1" target="_blank" rel="noopener noreferrer" className="cta-glow inline-block px-12 py-5 bg-gold-400 hover:bg-gold-500 text-night-900 font-dm-sans font-bold text-lg sm:text-xl rounded-xl transition-colors duration-300 mb-6" aria-label="Comprar Método Noches en Paz por $24.900 COP" data-id="element-19">
              ¡QUIERO QUE MI BEBÉ DUERMA YA!
            </a>

            {/* Trust signals */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-cream-200/50 font-dm-sans" data-id="element-20">
              <span className="flex items-center gap-2" data-id="element-21">
                <ShieldCheckIcon className="w-4 h-4 text-green-400/60" aria-hidden="true" data-id="element-22" />
                Pago seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-23">
                <DownloadIcon className="w-4 h-4 text-green-400/60" aria-hidden="true" data-id="element-24" />
                Descarga inmediata
              </span>
            </div>

            <p className="mt-6 font-dm-sans text-xs text-cream-200/30" data-id="element-25">
              Empieza esta misma noche
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}